import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import "react-rangeslider/lib/index.css"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  updateAbout as onUpdateAbout,
  getAbout as onGetAbout,
} from "store/contacts/actions";


import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { Base64 } from 'js-base64';

const EcommerceAddProduct = () => {
  document.title = "Hakkımızda Bilgileri | Kupon Admin Paneli";

  const dispatch = useDispatch();

  const [getContactEdit, setContactEdit] = useState(null);
  const [getHtmlDataLong, setHtmlDataLong] = useState(null);
  const [getHtmlDataLongKullanım, setHtmlDataLongKullanım] = useState(null);



    function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise(async (resolve, reject) => {
          try {
            const file = await loader.file; // loader.file bir Promise nesnesi döndürür
  
            // Burada file değişkeni Promise'ın çözüldüğü (fulfilled) durumda, yani File nesnesini içerir
            const body = new FormData();
            body.append('dataFile', file);
            console.log("file1c2313",file);
  
            try {
              const response = await axios.request({
                method: "POST",
                url: `https://berlinadmin.stechomeyazilim.info:9091/uploadfile`,
                data: body, // axios'ta "data" kullanın, "body" değil
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              });
  
              resolve({
                default: `https://megasubdomain.stechomeyazilim.info/${response.data.file.filename}`
              });
            } catch (error) {
              // Hata oluştuğunda throw ile hata fırlatın
              throw error;
            }
  
            // File nesnesini kullanarak istediğiniz işlemleri yapabilirsiniz
          } catch (error) {
            reject(error);
          }
        });
      },
      abort: () => {}
    };
  }
  
  
  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body }
  }
  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {


      mail: (getContactEdit && getContactEdit.Company_MailAdress) || '',
      number: (getContactEdit && getContactEdit.About_Number) || '',
      web: (getContactEdit && getContactEdit.WebAdress) || '',
      address: (getContactEdit && getContactEdit.AboutAdress) || '',

    },
    validationSchema: Yup.object({
      mail: Yup.string().required("Lütfen Mail Giriniz")
    }),
    onSubmit: (values) => {

      const updateOrder = {
        ID: users ? users[0].ID : 0,

        About_Desc: Base64.encode(getHtmlDataLong),
        TermsofUse: Base64.encode(getHtmlDataLongKullanım),
        Company_MailAdress: values.mail,
        About_Number: values.number,
        WebAdress: values.web,
        AboutAdress: values.address


      };
      // update order
      dispatch(onUpdateAbout(updateOrder));
      validation.resetForm();

    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.about,
  }));

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetAbout());

    }
  }, [dispatch, users]);

  useEffect(() => {
    if (users.length > 0) {
            setHtmlDataLong(users[0] ? Base64.decode(users[0].About_Desc) : '');
      setHtmlDataLongKullanım(users[0] ? Base64.decode(users[0].TermsofUse) : '');
      setContactEdit(users[0]);
    }
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users)) {
      setContactEdit(users[0]);
    }
  }, [users]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Hakkımızda Bilgileri" />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>Hakkımızda Bilgileri</CardTitle>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>

                      <div className="mb-3">
                        <Label htmlFor="productname">Mail Adresi</Label>
                        <Input
                          id="mail"
                          name="mail"
                          type="mail"
                          className="form-control"
                          placeholder="Mail Adresi"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.mail || ""}
                          invalid={
                            validation.touched.mail && validation.errors.mail ? true : false
                          }
                        />
                        {validation.touched.mail && validation.errors.mail ? (
                          <FormFeedback type="invalid">{validation.errors.mail}</FormFeedback>
                        ) : null}

                      </div>




                      <div className="mb-3">
                        <Label htmlFor="productname"> Adres </Label>
                        <Input
                          id="address"
                          name="address"
                          type="address"
                          className="form-control"
                          placeholder=" Adres"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address || ""}
                          invalid={
                            validation.touched.address && validation.errors.address ? true : false
                          }
                        />
                        {validation.touched.address && validation.errors.address ? (
                          <FormFeedback type="invalid">{validation.errors.address}</FormFeedback>
                        ) : null}

                      </div>




                      <div className="mb-3">
                        <Label htmlFor="productname">Web Adresi </Label>
                        <Input
                          id="web"
                          name="web"
                          type="web"
                          className="form-control"
                          placeholder="Web Adresi"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.web || ""}
                          invalid={
                            validation.touched.web && validation.errors.web ? true : false
                          }
                        />
                        {validation.touched.web && validation.errors.web ? (
                          <FormFeedback type="invalid">{validation.errors.web}</FormFeedback>
                        ) : null}

                      </div>




                      <div className="mb-3">
                        <Label htmlFor="productname">Telefon Numarası </Label>
                        <Input
                          id="number"
                          name="number"
                          type="number"
                          className="form-control"
                          placeholder="Web Adresi"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.number || ""}
                          invalid={
                            validation.touched.number && validation.errors.number ? true : false
                          }
                        />
                        {validation.touched.number && validation.errors.number ? (
                          <FormFeedback type="invalid">{validation.errors.number}</FormFeedback>
                        ) : null}

                      </div>


                      <div className="mb-3">
                        <Label className="form-label">Uzun Açıklama</Label>

                         <Form method="post">
                          <CKEditor
                            editor={Editor}
                            data={getHtmlDataLong}
                            config={{
                              // @ts-ignore
                              extraPlugins: [uploadPlugin]
                            }}
                            onReady={editor => {
                              // You can store the "editor" and use when it is needed.
                              console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setHtmlDataLong(data)

                            }}
                          />
                        </Form>
                      </div>


                      <div className="mb-3">
                        <Label className="form-label">Kullanım Koşulları</Label>

                          <Form method="post">
                          <CKEditor
                            editor={Editor}
                            data={getHtmlDataLongKullanım}
                            config={{
                              // @ts-ignore
                              extraPlugins: [uploadPlugin]
                            }}
                            onReady={editor => {
                              // You can store the "editor" and use when it is needed.
                              console.log('Editor is ready to use!', editor);
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setHtmlDataLongKullanım(data)

                            }}
                          />
                        </Form>
                      </div>


                    </Row>
                    <div className="d-flex flex-wrap gap-2">
                      <Button type="submit" color="primary" className="btn ">
                        Kaydet
                      </Button>
                      <Button type="submit" color="secondary" className=" ">
                        İptal
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>


            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EcommerceAddProduct
